import { Archive, Building2, UserCheck, X } from "lucide-react"
import { Button } from "../ui/button"
import { selectionLabel } from "../../services/leadBulk"

interface BulkActionsBarProps {
  readonly selectedCount: number
  readonly hiddenCount: number
  readonly onClear: () => void
  readonly onArchive: () => void
  readonly onAssign: () => void
  readonly onRefer: () => void
}

export function BulkActionsBar({
  selectedCount,
  hiddenCount,
  onClear,
  onArchive,
  onAssign,
  onRefer,
}: BulkActionsBarProps) {
  if (selectedCount === 0) {
    return null
  }

  return (
    <div className="sticky top-0 z-10 mb-3 flex flex-wrap items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2">
      <span className="text-sm font-medium text-slate-800">
        {selectionLabel(selectedCount, hiddenCount)}
      </span>
      <Button type="button" variant="outline" size="sm" onClick={onArchive}>
        <Archive className="mr-1 h-4 w-4" />
        Archive
      </Button>
      <Button type="button" variant="outline" size="sm" onClick={onAssign}>
        <UserCheck className="mr-1 h-4 w-4" />
        Assign attorney
      </Button>
      <Button type="button" variant="outline" size="sm" onClick={onRefer}>
        <Building2 className="mr-1 h-4 w-4" />
        Refer out
      </Button>
      <Button type="button" variant="ghost" size="sm" onClick={onClear} className="ml-auto">
        <X className="mr-1 h-4 w-4" />
        Clear
      </Button>
    </div>
  )
}
